import { z } from "zod";

export const setUnavailabilitySchema = z
	.object({
		is_unavailable: z.boolean().default(false),
		unavailable_until: z.coerce.date().nullable().optional(),
	})
	.strict();

export type SetUnavailabilityPayload = z.infer<typeof setUnavailabilitySchema>;
